import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import routes from '../routes/route';
import viewDeploymentOrganizations from './viewRelatedDeploymentOrganizations';

export default {
  attributeName: 'tagManager',
  canOpen: true,
  canEdit: true,
  canCreate: false,
  createPath: routes.TAG_MANAGER_NEW,
  editURL: routes.TAG_MANAGER_EDIT,
  canRemove: true,
  canRemoveWhen:[{"field":"locked","values":[null]}],
  
  emptyMessage: "You don't have master tags items, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'app',
      label: 'App',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Corresponding app.',
      default: '',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
      width: '8rem',

    },
    {
      attributeName: 'type',
      label: 'Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The type can be "rooms" or "content".',
      default: '',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
      width: '8rem',
    },
    {
      attributeName: 'typeTagAssignment',
      label: 'Assignment',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The assignment of the master tag.',
      default: '',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
      width: '8rem',

    },
    {
      attributeName: 'typeTagName',
      label: 'Category',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The category of the master tag.',
      default: '',
      width: '8rem',

      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The name of the master tag.',
      default: '',
      canEdit: false,
      canCreate: false,
      canFilter: true,
      canOrder: true,
    },
    {
      attributeName: 'visible',
      helpText: 'Visible',
      type: FormInputTypes.CHECKBOX,
      required: true,
      label: 'Visible',
      width: '5rem',

    },    
    {
      attributeName: 'score',
      helpText: 'Score of the tag',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      label: 'Score',
      placeholder: 'Score...',
      width: '5rem',

    },
    {
      attributeName: 'locked',
      label: 'Locked',
      type: FormInputTypes.LINK,
      icon: IconType.LOCK,
      width: '5rem',
      target:'_self',
      iconSize:'sm',
      iconColor:'#17a2b8',
      helpText: 'Locked Tag.',
      hasClick:false,
      emptyValue:true,
      // visibleWhen:{"field":"locked","value":1}
    },   
    {
      attributeName: 'videoPreview',
      label: 'Video Preview',
      type: FormInputTypes.TAGS_PREVIEW,
      helpText: 'Tag preview in video',
      width: '200px',
    },
    {
      attributeName: 'extendedInfoPreview',
      label: 'Ex. Info Preview',
      type: FormInputTypes.TAGS_PREVIEW,
      helpText: 'Tag preview in extended info',
      width: '200px',
    },
  
  ],
};


